var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-view"},[_c('div',{staticClass:"o-view-bg"}),_c('div',{staticClass:"o-view-right"},[(_vm.defaultlist.value1)?_c('div',{ref:"autoplay",staticClass:"otext2 more-line",on:{"mouseenter":_vm.mouseenterEvent,"mouseleave":_vm.mouseleaveEvent}},[_vm._v(" "+_vm._s(_vm.defaultlist.value1)+" ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }